import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { ApiClient, getGtcHubClientInstance } from 'src/client/apiClient';
import { UNSUBSCRIBE_API_NAME } from 'src/constants/ApiConstants';
import { UnsubscribeRequest, UnsubscribeResponse } from 'src/types/Unsubscribe';

export function useUnsubscribe(
  componentName: string,
): UseMutationResult<
  UnsubscribeResponse,
  unknown,
  UnsubscribeRequest,
  unknown
> {
  return useMutation<UnsubscribeResponse, unknown, UnsubscribeRequest>({
    mutationFn: (unsubscribeRequest: UnsubscribeRequest) => {
      const client: ApiClient = getGtcHubClientInstance();

      return client.client.request({
        url: `/unsubscribe/${encodeURIComponent(
          unsubscribeRequest.subscriptionId,
        )}`,
        method: 'post',
        meta: {
          apiName: UNSUBSCRIBE_API_NAME,
          component: componentName,
        },
        data: {
          reason: unsubscribeRequest.reason,
        },
      });
    },
  });
}
